import { useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { useLocation, useNavigate } from 'react-router-dom';
import AccountInformation from '../../../components/AccountInformation';
import RestaurantInformation from '../../../components/RestaurantInformation';
import PageHeader from '../../../components/PageHeader';
import { useMenuLayoutContext } from '../../../contexts/MenuLayoutContext';
import { useManagerContext } from '../../../contexts/ManagerContext';
import Button from '../../../components/common/Button';
import { PAGE_EDIT_RESTAURANT } from '../../../constants/UriConstants';
import { useRestaurantContext } from '../../../contexts/RestaurantContext';
import { isSettingsAccountRoute } from '../../../components/Sidebar/sidebarNavigation';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

const Settings = () => {
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const { loadManager } = useManagerContext();
  const { loadLayouts } = useMenuLayoutContext();
  const { currentRestaurant } = useRestaurantContext();
  const isAccountView = isSettingsAccountRoute(pathname);

  useEffect(() => {
    loadLayouts();
    loadManager();
  }, [loadManager, loadLayouts]);

  return (
    <div className="settings-page-container">
      <PageHeader title={isAccountView ? 'SETTINGS' : 'RESTAURANT PROFILE'}>
        {!isAccountView && currentRestaurant !== null ? (
          <Button
            onClick={() => navigate(`/${PAGE_EDIT_RESTAURANT}/basic`)}
            className="page-header__action-button"
          >
            EDIT
          </Button>
        ) : null}
      </PageHeader>
      <div className="settings-container">
        <div className="settings-content">
          {isAccountView ? (
            <Elements stripe={stripePromise}>
              <AccountInformation />
            </Elements>
          ) : (
            <RestaurantInformation />
          )}
        </div>
      </div>
    </div>
  );
};

export default Settings;
